import { useEffect, useRef, useState } from 'react'

export function useElementRect(element: Element | null): DOMRect | null {
  const [rect, setRect] = useState<DOMRect | null>(() => (element ? element.getBoundingClientRect() : null))

  const rectRef = useRef(rect)
  rectRef.current = rect

  useEffect(() => {
    if (element) {
      const update = () => {
        setRect(element.getBoundingClientRect())
      }

      if (rectRef.current === null) {
        update()
      }

      window.addEventListener('resize', update)

      return () => {
        setRect(null)

        window.removeEventListener('resize', update)
      }
    }
  }, [element])

  return rect
}
